<div class="wholebody container-fluid">
    <div class="row">
        <div class="col-lg-7"></div>
        <div class="col-lg-5 col-sm-12 login-module">
            <div class="row">
                <div class="login-div">
                    <p class="login-text">Logged Out</p>
                </div>
            </div>
            <div class="row">
                <div class="log-out-text">
                    <p class="login-text">
                        You've been logged out of Ai Advisor, however you may still be logged in to your
                        single sign-on identity provider.
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="login-button-div">
                    <button (click)="login()" class="login-button"><span class="login-button-text">
                        J&J Single Sign-on (SSO)</span></button>
                </div>
            </div>
        </div>
    </div>
</div>